import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { UsuarioService } from '../usuario/usuario.service';

@Injectable()
export class LoginGuard implements CanActivate {

	constructor(
    public _usuarioService: UsuarioService,
    public router: Router
	) { }

  canActivate() {

    if (this._usuarioService.estaLogeado()) {
      console.log('pasa por el login guard');
      return true;
      
    } else {
      console.log('bloqueado por el login guard');
      this._usuarioService.logout();
      return false;
    }

  }
}
